import { render, staticRenderFns } from "./groupDialog.vue?vue&type=template&id=5cca9e99"
import script from "./groupDialog.vue?vue&type=script&lang=js"
export * from "./groupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports